// extracted by mini-css-extract-plugin
export var breadcrumbs = "Table-module--breadcrumbs--b1772";
export var childLink = "Table-module--childLink--4f4df";
export var description = "Table-module--description--a9c85";
export var table = "Table-module--table--b8965";
export var wrap = "Table-module--wrap--f9fd7";